/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnostTypObjektu extends GContentBase<SeznamAdmVlastnostTypObjektuObj> {
        private seznamObj: SeznamAdmVlastnostTypObjektuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostTypObjektuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnostTypObjektuNew",
                contentCaption: "jres:33000415", //RC 33000505 : Roz���en� vlastnosti
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{typ_obj_txt} - {ixs_txt} - {ico}"
                },
                gridSettings: {
                    columnOrder: "typ_obj_txt,typ_prirazeni_txt,typ_vps_txt,ixs_txt,poradi,ico_txt,dat_zmena,zmenu_provedl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostTypObjektuObj extends GAdmSeznamBase {
        private typ_obj: number;
        private ico: string;
        private ixs: string;
        private typ_vps: number;
        private srv: GContent;
        private typ_obj_ginvovl: number;
        private typ_obj_ginvovp: number;

        private getSrv(): GContent {
            if (this.srv == undefined && this.srv == null)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu")
            return this.srv;
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostTypObjektuNew", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnostTypObjektuNew",
                newRecord: isNew,
                typ_obj: isNew == true ? ((this.typ_obj) ? this.typ_obj : null) : data.typ_obj,
                ixs: isNew == true ? ((this.ixs) ? this.ixs : null) : data.ixs,
                ico: isNew == true ? ((this.ico) ? this.ico : null) : data.ico,
                typ_vps: isNew == true ? ((this.typ_vps != null && this.typ_vps != undefined) ? this.typ_vps : null) : data.typ_vps,
                typ_prirazeni: isNew == true ? 0 : data.typ_prirazeni 
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                // Pokud m�m objekt je mo�nost p�idat hromadn� vlastnosti, profily a struktury
                actNewVlastnostiHromadne: {
                    caption: "jres:33000481", //RC 33000481 : P�idat vlastnosti
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.newVlastnostiHromadne();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                 {
                     caption: "jres:32000121",
                     icon: "gi-plus",
                     favorite: true,
                     action: this.cnt.actions.actNewDetail,
                     children: (this.typ_obj != null && this.typ_obj != undefined) ?
                         [
                             { action: this.cnt.actions.actNewVlastnostiHromadne }
                         ] : undefined
                },
                "actAddToComparison*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            if (this.typ_vps != null && this.typ_vps != undefined) {
                switch (this.typ_vps) {
                    case 0:
                        this.filterForm.addRow("jres:29802650").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                            serverFilters: {
                                aktivita: 100,
                                priz_vir: 0
                            },
                            name: "ixs",
                            model: "model.ixs=value.ixs_pro",
                            disabled: this.typ_vps != null && this.typ_vps != undefined ? true : false,
                            dropdown: true
                        })
                        break;
                    case 10:
                        this.filterForm.addRow("jres:29802692").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                            serverFilters: {
                                aktivita: 100,
                                priz_vir: 0
                            },
                            name: "ixs",
                            model: "model.ixs=value.ixs_stv",
                            disabled: this.typ_vps ? true : false,
                            dropdown: true
                        })
                        break;
                    case 20:
                        this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                            serverFilters: {
                                aktivita: 100
                            },
                            name: "ixs",
                            model: "model.ixs=value.ixs_vla",
                            disabled: this.typ_vps ? true : false,
                            dropdown: true
                        })
                        break;
                }
            }
            this.filterForm.addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                name: "typ_obj",
                model: "model.typ_obj=value.typ_obj",
                disabled: this.typ_obj ? true : false,
                dropdown: true
            })/*.addRow("jres:32131046").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                name: "ico",
                model: "model.ico=value.ico",
                disabled: this.ico ? true : false,
                dropdown: true
            })*/
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs)
                hardFilter["ixs"] = this.ixs
            if (this.typ_obj)
                hardFilter["typ_obj"] = this.typ_obj
            if (this.ico)
                hardFilter["ico"] = this.ico
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs)
                data["ixs"] = this.ixs
            if (this.typ_obj)
                data["typ_obj"] = this.typ_obj
            if (this.ico)
                data["ico"] = this.ico
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnostTypObjektu.list({ filters: filterData }).getView().then((data) => {
                this.view = data;
                this.cnt.isl.AdmVlastnostTypSubjektu.list({ filters: filterData }).getData().then((data2) => {
                    this.view.updateData(data2, "add");
                    this.grid.ggrid('setData', this.view);
                }) 
            })
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.typ_obj, data.ixs, data.ico),
                nazev: ""
            }
        }

        createContentCaption(): string {
            return "{0} ({1} + {2})".format(this.options.contentCaption, this.typ_obj_ginvovl, this.typ_obj_ginvovp);
        }

        private newVlastnostiHromadne() {
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostTypObjektuListDto[] = [];
            data.push({
                typ_obj: this.typ_obj
            })
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmVlastnostTypObjektu"], { ID: "HromadnaOperaceAdmVlastnostTypObjektu", data: data }, "", 1000, 600)
        }
    }
}